"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n"])));

exports.Container = Container;

var Loader = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  span {\n    display: inline-block;\n    border-radius: 100%;\n    margin: 35px 5px;\n    opacity: 1;\n  }\n  .first {\n    background-color: #ff75cf;\n  }\n  .second {\n    background-color: #e33aa9;\n  }\n  .third {\n    background-color: #b12d84;\n  }\n  span:nth-child(1) {\n    width: 16px;\n    height: 16px;\n    animation: opacitychange 1s ease-in-out infinite;\n  }\n  span:nth-child(2) {\n    width: 18px;\n    height: 18px;\n\n    animation: opacitychange 1s ease-in-out 0.33s infinite;\n  }\n  span:nth-child(3) {\n    width: 20px;\n    height: 20px;\n\n    animation: opacitychange 1s ease-in-out 0.66s infinite;\n  }\n  @keyframes opacitychange {\n    0%,\n    100% {\n      opacity: 0;\n    }\n    60% {\n      opacity: 1;\n    }\n  }\n"])));

exports.Loader = Loader;